/**
 * Navigation configuration for Gamin ENGINE.
 * Consumed by AppHeader and AppFooter components.
 */

import type {
  GlobalHeaderProps,
  MobileBottomBarProps,
  GlobalFooterProps,
} from '@engagexp/legendary-ui-primitives';
import {
  Home,
  Trophy,
  Users,
  Bell,
  Facebook,
  Instagram,
  Twitter,
  Linkedin,
  Youtube,
} from 'lucide-react';

export const navLinks: GlobalHeaderProps['navLinks'] = [
  { title: 'Tournament', url: '/tournament' },
  { title: 'Leaderboard', url: '/leaderboard' },
  { title: 'Community', url: '/community' },
];

export const mobileBottomBar: MobileBottomBarProps = {
  items: [
    { icon: <Home size={20} />, label: 'Home', href: '/', active: true },
    { icon: <Trophy size={20} />, label: 'Tournament', href: '/tournament' },
    { icon: <Users size={20} />, label: 'Community', href: '/community' },
    { icon: <Bell size={20} />, label: 'Notifications', href: '/notifications' },
  ],
  cta: { label: 'Create Tournament', href: '/tournament/create' },
};

export const footerColumns: GlobalFooterProps['columns'] = [
  {
    title: 'Product',
    links: [
      { title: 'Features', url: '#' },
      { title: 'Pricing', url: '#' },
      { title: 'Security', url: '#' },
      { title: 'Roadmap', url: '#' },
    ],
  },
  {
    title: 'Support',
    links: [
      { title: 'Help Center', url: '#' },
      { title: 'Contact', url: '#' },
      { title: 'Status', url: '#' },
      { title: 'Community', url: '#' },
    ],
  },
  {
    title: 'Legal',
    links: [
      { title: 'Privacy', url: '#' },
      { title: 'Terms', url: '#' },
      { title: 'Cookies', url: '#' },
    ],
  },
];

export const socialLinks: GlobalFooterProps['socialLinks'] = [
  { icon: <Facebook size={20} />, href: '#', label: 'Gamin ENGINE on Facebook' },
  { icon: <Instagram size={20} />, href: '#', label: 'Gamin ENGINE on Instagram' },
  { icon: <Twitter size={20} />, href: '#', label: 'Gamin ENGINE on Twitter/X' },
  { icon: <Linkedin size={20} />, href: '#', label: 'Gamin ENGINE on LinkedIn' },
  { icon: <Youtube size={20} />, href: '#', label: 'Gamin ENGINE on YouTube' },
];

export const footerLegalLinks: GlobalFooterProps['legalLinks'] = [
  { title: 'Privacy Policy', url: '#' },
  { title: 'Terms of Service', url: '#' },
  { title: 'Cookie Settings', url: '#' },
];

export const footerLegalText = '© 2026 EngageXP. All rights reserved.';
